<template>
  <div>
    <SGPTabsMenuHorizontalComponent :itemsTabs="itemsTabs" :propsPage="{ itemsVertical }" vertical />

    <SGPLoadingComponent v-if="loadingTarefasMobilidades" />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FormulariosFiltros',

  data() {
    return {
      filtro: {
        ctrl_tarefa_id: null,
        recuperar_destino: 0
      }
    }
  },

  computed: {
    ...mapGetters('ctrlTarefas', ['listaDeTarefasAtivas', 'loadingTarefas']),
    ...mapGetters('ctrlTarefasMobilidades', ['listaDeMobilidadesTarefaOrigem', 'loadingTarefasMobilidades']),

    itemsTabs() {
      return [
        {
          key: 'FDF',
          label: 'Filtros de Formulários',
          nameComponent: 'SGPTabsMenuVerticalComponent',
          pathComponent: 'common/sgp-components/SGPOrdemServico/SGPTabsMenuVerticalComponent'
        }
      ]
    },

    itemsVertical() {
      return [
        {
          key: 'tabFormularioMobilidade',
          label: 'Formulários Mobilidades',
          nameComponent: 'FormularioMobilidadePage',
          pathComponent: 'modules/workflow/tarefas-mobilidades/pages/FormularioMobilidadePage'
        },
        {
          key: 'tabFormularioOpcao',
          label: 'Formulários Opções',
          nameComponent: 'FormularioOpcaoPage',
          pathComponent: 'modules/workflow/tarefas-mobilidades/pages/FormularioOpcaoPage'
        },

      ]
    },

    listagem() {
      return this.listaDeMobilidadesTarefaOrigem
        .map(item => {
          item.redirecionar = `/workflow/tarefas-mobilidades-metodos/${item.id}`;
          return item;
        });
    },

    listaDeTarefasAtivas() {
      return this.listaDeTarefasAtivas.filter(tarefa => tarefa.deleted_at === null)
    },

    colunas() {
      return [
        {
          key: 'ctrl_tarefas.map',
          label: 'MAP',
          sortable: false
        },
        {
          key: 'ctrl_tarefa_origem.tarefa',
          label: 'Tarefa Origem',
          sortable: false
        },
        {
          key: 'ctrl_tipo_tarefa.tipo',
          label: 'Tipo Tarefa Origem',
          sortable: false
        },
        {
          key: 'ctrl_conclusao.conclusao',
          label: 'Tipo Conclusão',
          sortable: false
        },
        {
          key: 'ctrl_tarefa_destino.tarefa',
          label: 'Tarefa Destino',
          sortable: false
        },
        {
          key: 'redirecionar',
          label: 'Associar Mobilidades',
          sortable: false,
          align: 'center'
        },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlTarefas', [
      'listarTarefasComFiltro',
    ]),

    ...mapActions('ctrlTarefasMobilidades', [
      'recuperarMobilidadeTarefaOrigem'
    ]),

    ...mapActions('ctrlFormularioDinamico', ['listarFormulariosDinamicos']),

    filtrarMobilidadesDestino() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.recuperarMobilidadeTarefaOrigem(this.filtro);
        }
      });
    }

  }
}
</script>